module.exports={
  "map-overview": {
    "key": "map-overview",
    "northEast": "37.511928686036484, -121.95345345255602",
    "southWest": "37.38892836387657, -122.15564141399817",
    "mobile_northEast": "37.515811156019424, -121.99206149082663",
    "mobile_southWest": "37.380798549806784, -122.1902290633898",
    "map_class": "",
    "duration": 1,
    "assets": "roads, facebook_parcels, google_parcels",
    "label_ids": "sf-bay, highway-680, highway-880, highway-280, highway-101, highway-84, google, facebook, palo-alto, mountain-view, sunnyvale, san-jose, fremont, hayward, cupertino, menlo-park",
    "description": "overview at beginning"
  },
  "map-google": {
    "key": "map-google",
    "northEast": "37.42496722460027, -121.97281282061404",
    "southWest": "37.405877294525745, -122.10133993197756",
    "mobile_northEast": "37.42560417083857, -122.0005916285805",
    "mobile_southWest": "37.39794509387222, -122.09617488602922",
    "map_class": "",
    "duration": 1,
    "assets": "roads, google_parcels_discrete, facebook_parcels_faded, sunnyvale_outline",
    "label_ids": "sf-bay, highway-101, highway-84, mountain-view, sunnyvale, google-big",
    "description": "fly over to google overview"
  },
  "map-facebook-closeup": {
    "key": "map-facebook-closeup",
    "northEast": "37.50324347665734, -122.12277866463276",
    "southWest": "37.47304264474799, -122.18375484899977",
    "mobile_northEast": "37.489475737206284, -122.1443427570447",
    "mobile_southWest": "37.4742212839343, -122.17400465365669",
    "map_class": "",
    "duration": 1,
    "assets": "roads, facebook_parcels_faded, facebook_buildings",
    "label_ids": "sf-bay, highway-101, highway-84, palo-alto, mountain-view, sunnyvale, san-jose, fremont, redwood-city, hayward, cupertino, facebook-big",
    "description": "zoom in and look at facebook's parcels"
  },
  "map-facebook-buildings": {
    "key": "map-facebook-buildings",
    "northEast": "37.481936624932004, -122.151498508548",
    "southWest": "37.479735991001505, -122.1617152124788",
    "mobile_northEast": "37.48142167770819, -122.15246690114262",
    "mobile_southWest": "37.480740562766364, -122.16060279724608",
    "map_class": "close-up",
    "duration": 1,
    "assets": "fb21",
    "label_ids": "sf-bay"
  },
  "map-neighborhoods": {
    "key": "map-neighborhoods",
    "northEast": "37.48885527721372, -122.12458253852988",
    "southWest": "37.45708342806124, -122.17646895232345",
    "mobile_northEast": "37.49440165936197, -122.11981736713848",
    "mobile_southWest": "37.449847285291526, -122.17034211529936",
    "map_class": "",
    "duration": 1,
    "assets": "roads, facebook_parcels_faded , facebook_buildings, east_palo_alto, belle_haven",
    "label_ids": "epa, bh, sf-bay",
    "description": "highlight where neighborhoods are adjacent to fb",
    "undefined": "google_parcels"
  },
  "map-flood1": {
    "key": "map-flood1",
    "northEast": "37.48885527721372, -122.12458253852988",
    "southWest": "37.45708342806124, -122.17646895232345",
    "mobile_northEast": "37.49440165936197, -122.11981736713848",
    "mobile_southWest": "37.449847285291526, -122.17034211529936",
    "map_class": "",
    "duration": 1,
    "assets": "roads, east_palo_alto, belle_haven, facebook_buildings, flood50",
    "label_ids": "epa, bh",
    "description": "flood with 50 years of sea level rise"
  },
  "map-flood2": {
    "key": "map-flood2",
    "northEast": "37.48885527721372, -122.12458253852988",
    "southWest": "37.45708342806124, -122.17646895232345",
    "mobile_northEast": "37.49440165936197, -122.11981736713848",
    "mobile_southWest": "37.449847285291526, -122.17034211529936",
    "map_class": "",
    "duration": 1,
    "assets": "roads, east_palo_alto, belle_haven, facebook_buildings, flood50, flood100",
    "label_ids": "epa, bh",
    "description": "flood with 100 years of sea level rise"
  },
  "map-flood-zoomout": {
    "key": "map-flood-zoomout",
    "northEast": "37.49320495998735, -122.05234304424785",
    "southWest": "37.39485388384441, -122.11744052539663",
    "mobile_northEast": "37.48078852215426, -122.01923194068995",
    "mobile_southWest": "37.385238962812124, -122.16691201015746",
    "map_class": "",
    "duration": 1,
    "assets": "roads, east_palo_alto, belle_haven, facebook_parcels, google_parcels, flood100",
    "label_ids": "sf-bay",
    "description": "flood with 100 years of sea level risel, zoom out"
  },
  "map-levee": {
    "key": "map-levee",
    "northEast": "37.49320495998735, -122.05234304424785",
    "southWest": "37.39485388384441, -122.11744052539663",
    "mobile_northEast": "37.48078852215426, -122.01923194068995",
    "mobile_southWest": "37.385238962812124, -122.16691201015746",
    "map_class": "",
    "duration": 1,
    "assets": "roads, east_palo_alto, belle_haven, facebook_parcels, google_parcels, facebook_levee, google_levee, flood_100_levee_clipped",
    "label_ids": "sf-bay",
    "description": "map of levees of both areas",
    "undefined": "google_levee"
  },
  "map-facebook-three": {
    "key": "map-facebook-three",
    "northEast": "37.48299610329457, -122.15010267667842",
    "southWest": "37.38040254791545, -122.15526584620933",
    "mobile_northEast": "",
    "mobile_southWest": "",
    "map_class": "",
    "duration": 1,
    "assets": "roads, facebook_parcels_faded",
    "label_ids": "sf-bay, highway-101, epa, bh",
    "description": "fade out facebook parcels, but leave lightly visible. Highlight 3 big expensive buildings on top."
  },
  "map-facebook": {
    "key": "map-facebook",
    "northEast": "37.49745096248473, -122.11192033465665",
    "southWest": "37.45361417323746, -122.16849987402837",
    "mobile_northEast": "37.50879537861532, -122.11447755845789",
    "mobile_southWest": "37.46835130760778, -122.16759279833285",
    "map_class": "",
    "duration": 0,
    "assets": "roads,",
    "label_ids": "sf-bay"
  },
  "map-facebook-levee": {
    "key": "map-facebook-levee",
    "northEast": "37.50563381588784, -122.09696143532379",
    "southWest": "37.45868258155793, -122.19952375003506",
    "mobile_northEast": "",
    "mobile_southWest": "",
    "map_class": "",
    "duration": 2,
    "assets": "roads, facebook_levee"
  },
  "sunnyvale-map": {
    "key": "sunnyvale-map",
    "northEast": "37.42222543044709, -121.9873365385381",
    "southWest": "37.4014773248027, -122.03619614309783",
    "mobile_northEast": "37.42121135553512, -122.0110692872688",
    "mobile_southWest": "37.358771799820516, -122.02654124216805",
    "map_class": "year-2013, year-2014, year-2016, year-2017, year-2018, year-2019, year-2020",
    "duration": 1,
    "assets": "roads, sunnyvale",
    "label_ids": "sf-bay, highway-101, highway-84, palo-alto, mountain-view, sunnyvale, san-jose, fremont, redwood-city, hayward, cupertino",
    "description": "fly over to google overview"
  },
  "east-pa-image": {
    "key": "east-pa-image",
    "northEast": "37.48376708611954, -122.11728297268746",
    "southWest": "37.45015666939371, -122.17725664397328",
    "mobile_northEast": "37.49440165936197, -122.11981736713848",
    "mobile_southWest": "37.449847285291526, -122.17034211529936",
    "map_class": "",
    "duration": 1,
    "assets": "roads, facebook_parcels, east_palo_alto, belle_haven",
    "label_ids": "epa, bh"
  },
  "map-google-levee": {
    "key": "map-google-levee",
    "northEast": "37.434296699110654, -121.9908154509561",
    "southWest": "37.401721182550126, -122.03574288504352",
    "mobile_northEast": "37.434296699110654, -121.9908154509561",
    "mobile_southWest": "37.401721182550126, -122.03574288504352",
    "map_class": "",
    "duration": 2,
    "assets": "roads, google_parcels_discrete, facebook_levee, google_levee, flood_100_levee_clipped",
    "label_ids": "sf-bay, highway-101, highway-84, palo-alto, mountain-view, sunnyvale, san-jose, fremont, redwood-city, hayward, cupertino",
    "description": "fly over to google overview"
  },
  "google-flood": {
    "key": "google-flood",
    "northEast": "37.42222543044709, -121.9873365385381",
    "southWest": "37.4014773248027, -122.03619614309783",
    "mobile_northEast": "37.434296699110654, -121.9908154509561",
    "mobile_southWest": "37.401721182550126, -122.03574288504352",
    "map_class": "",
    "duration": 1,
    "assets": "roads, google_parcels_discrete, flood50"
  },
  "map-levee-neighborhoods": {
    "key": "map-levee-neighborhoods",
    "northEast": "37.49469558001175, -122.1309199882757",
    "southWest": "37.45110935155329, -122.17215021792828",
    "mobile_northEast": "37.49440165936197, -122.11981736713848",
    "mobile_southWest": "37.449847285291526, -122.17034211529936",
    "map_class": "",
    "duration": 1,
    "assets": "roads, east_palo_alto, belle_haven, facebook_parcels_faded, facebook_buildings, facebook_levee, flood_100_levee_clipped",
    "label_ids": "sf-bay, epa, bh",
    "description": "map of levees of both areas",
    "undefined": "google_levee"
  }
}